<script lang="ts">
  import Dialog, { Content } from '@smui/dialog';
  import { getAppConfig } from '../../../common/config/app-config';
  import { formatNumber, getStr, globalCurrencyTag } from '../../../common/util';
  import Tag from '../../common/components/tag/Tag.svelte';
  import Text from '../../common/components/Text.svelte';
  import {
    pdpMoreInfoActiveTab,
    pdpTitleData,
    showHighlightDetailsPopup,
    showPdpMoreInfoModal,
  } from './../store/pdp_store';
  import ExtraProductTitle from './ExtraProductTitle.svelte';
  import HighlightDetailsSlider from './HighlightDetailsSlider.svelte';

  export let data: any;

  const { bnplBaseetaPaymentModeEnabled } = getAppConfig();

  $: productImageUrl = `https:${data?.amplienceProductBaseUrl}&h=250`;

  function closeHandler() {
    showHighlightDetailsPopup.set(false);
  }

  function openGeekOutModal() {
    closeHandler();
    setTimeout(() => {
      $showPdpMoreInfoModal = true;
      $pdpMoreInfoActiveTab = 'Discover';
    }, 400);
  }
</script>

<Dialog
  open={$showHighlightDetailsPopup}
  fullscreen
  aria-labelledby="Highlight details popup"
  surface$style="width:100vw;height:100dvh;border-radius:0;max-height:100vh"
  on:SMUIDialog:closed={closeHandler}
>
  <div class="close-btn">
    <svg
      class="button-close"
      on:click={() => closeHandler()}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 30C17.9667 30 20.8668 29.1203 23.3335 27.472C25.8003 25.8238 27.7229 23.4811 28.8582 20.7403C29.9935 17.9994 30.2906 14.9834 29.7118 12.0737C29.133 9.16394 27.7044 6.49119 25.6066 4.3934C23.5088 2.29562 20.8361 0.867006 17.9263 0.288227C15.0166 -0.290551 12.0006 0.0064992 9.25975 1.14181C6.51885 2.27713 4.17618 4.19972 2.52796 6.66645C0.879734 9.13319 0 12.0333 0 15C0.00446174 18.9769 1.58625 22.7896 4.39832 25.6017C7.2104 28.4138 11.0231 29.9955 15 30ZM15 1.42858C17.6842 1.42858 20.3081 2.22453 22.5399 3.71578C24.7717 5.20702 26.5112 7.32659 27.5384 9.80645C28.5655 12.2863 28.8343 15.0151 28.3106 17.6477C27.787 20.2803 26.4944 22.6985 24.5964 24.5965C22.6984 26.4944 20.2802 27.787 17.6476 28.3107C15.0151 28.8343 12.2863 28.5656 9.80644 27.5384C7.32658 26.5112 5.20702 24.7717 3.71577 22.5399C2.22452 20.3081 1.42857 17.6842 1.42857 15C1.43266 11.4019 2.86381 7.95232 5.40806 5.40807C7.95231 2.86382 11.4019 1.43267 15 1.42858ZM10.2093 18.7807L13.99 15L10.2093 11.2193C10.0791 11.0846 10.0071 10.9042 10.0088 10.7169C10.0104 10.5296 10.0855 10.3505 10.218 10.218C10.3504 10.0856 10.5295 10.0105 10.7168 10.0088C10.9041 10.0072 11.0845 10.0792 11.2193 10.2093L15 13.99L18.7807 10.2093C18.9154 10.0792 19.0958 10.0072 19.2831 10.0088C19.4704 10.0105 19.6495 10.0856 19.782 10.218C19.9144 10.3504 19.9895 10.5296 19.9912 10.7169C19.9928 10.9042 19.9208 11.0846 19.7907 11.2193L16.01 15L19.7907 18.7807C19.8589 18.8466 19.9133 18.9254 19.9508 19.0125C19.9882 19.0997 20.0079 19.1934 20.0087 19.2883C20.0096 19.3831 19.9915 19.4772 19.9556 19.5649C19.9197 19.6527 19.8666 19.7325 19.7995 19.7995C19.7325 19.8666 19.6527 19.9196 19.5649 19.9556C19.4772 19.9915 19.3831 20.0096 19.2883 20.0087C19.1934 20.0079 19.0997 19.9882 19.0125 19.9508C18.9254 19.9133 18.8466 19.8589 18.7807 19.7907L15 16.01L11.2193 19.7907C11.0846 19.9209 10.9042 19.9929 10.7169 19.9912C10.5296 19.9896 10.3504 19.9145 10.218 19.782C10.0856 19.6496 10.0105 19.4705 10.0088 19.2832C10.0072 19.0959 10.0792 18.9155 10.2093 18.7807L10.2093 18.7807Z"
        fill="#FFD400"
      />
    </svg>
  </div>

  <Content>
    <section class="highlight-details-container">
      <section class="left-section">
        <div class="image-box">
          <img class="product-image" src={productImageUrl} alt="" />
        </div>
        <div class="info-box">
          <ExtraProductTitle data={$pdpTitleData} />
          <div class="price-box">
            <!-- Price -->
            <section class="price-info bordered">
              <section class="left-price-info">
                <section class="line1">
                  <span class="price"
                    >{@html globalCurrencyTag}&nbsp;<strong>{formatNumber(data?.productSellingPrice)}</strong></span
                  >
                  <span class="vat">
                    <Text key="extra.product.cashback.inclusiveOfVAT" />
                  </span>
                </section>
                {#if data?.hasDiscount}
                  <section class="line2">
                    <span class="old-price">{formatNumber(data?.price?.formattedValue)}</span>
                    <span class="savings">
                      <Text key="extra.product.cashback.save" />
                      {@html globalCurrencyTag}
                      {formatNumber(data?.savingAmount?.formattedValue)}
                    </span>
                  </section>
                {/if}
              </section>
              {#if data?.hasDiscount}
                <section class="right-price-info">
                  <Tag
                    label={getStr('product.percentageDiscount.off', [data?.percentageDiscount?.formattedValue])}
                    backgroundColorCode="#EF7E2C"
                    textColorCode="#FFFFFF"
                  />
                </section>
              {/if}
            </section>
            <!-- EMI/Tasheel -->
            {#if data?.tasheelPriceValuesList && data?.tasheelPriceValuesList.length > 0 && bnplBaseetaPaymentModeEnabled}
              <section class="price-info">
                <section class="left-price-info">
                  <section class="line1">
                    <span class="price">
                      <Text
                        key="extra.price.per.mon.text"
                        args={[globalCurrencyTag, formatNumber(data?.tasheelPrice)]}
                      />
                    </span>
                  </section>
                  <section class="line2">
                    <span class="interest">
                      <Text
                        key="extra.tasheel.priceValue.desc"
                        args={[data?.tasheelPercentage, data?.tasheelInstallMonths]}
                      />
                    </span>
                  </section>
                </section>
                <section class="right-price-info">
                  <img class="tasheel-image" src={data?.tasheelImageUrl} alt="" />
                </section>
              </section>
            {/if}
          </div>
        </div>
      </section>
      <section class="right-section">
        {#if data?.keyHighlights}
          <HighlightDetailsSlider
            visible={$showHighlightDetailsPopup}
            keyHighlights={data?.keyHighlights}
            on:close={() => openGeekOutModal()}
          />
        {/if}
      </section>
    </section>
  </Content>
</Dialog>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  :global(.mdc-dialog.mdc-dialog--fullscreen) {
    z-index: 10000;
    height: 100dvh;
    :global(.mdc-dialog__content) {
      padding: 0 !important;
    }
    :global(.close-btn) {
      position: absolute;
      top: 18px;
      right: 18px;
      cursor: pointer;
      z-index: 10;
      width: 20px;
      height: 20px;

      @include desktop-min-width {
        top: 27px;
        right: 27px;
        width: 30px;
        height: 30px;
      }
    }
  }

  .highlight-details-container {
    display: flex;
    min-height: 100%;

    .left-section {
      display: none;
      flex-basis: 40%;
      background-color: $primary-white;
      color: $neutral-dark-01;
      padding: 64px 48px 36px;
      .image-box {
        // max-width: 300px;
        height: 300px;
        // padding: 25px 45px 25px 46px;
        text-align: center;
        .product-image {
          // height: 100%;
          // width: 100%;
        }
      }

      :global(.product_title) {
        padding-top: 24px;
      }
      .price-box {
        margin-top: 48px;
        display: flex;
        flex-direction: column;
        gap: 32px;

        .price-info {
          display: flex;

          .left-price-info {
            flex-grow: 1;

            .line1 {
              display: flex;
              gap: 4px;
              align-items: baseline;

              .price {
                font-weight: 400;
                font-size: 28px;
                line-height: 32px;

                strong {
                  font-weight: 700;
                }
              }
              .vat {
                font-weight: 400;
                font-size: 12px;
                line-height: 14px;
              }
            }
            .line2 {
              margin-top: 4px;
              display: flex;
              gap: 6px;

              .old-price {
                font-weight: 400;
                font-size: 16px;
                line-height: 18px;
                color: $neutral-dark-02;
                text-decoration: line-through;
              }
              .savings {
                font-weight: 700;
                font-size: 16px;
                line-height: 18px;
                color: $functional-orange;
              }
              .interest {
                font-weight: 400;
                font-size: 16px;
                line-height: 18px;
              }
            }
          }
          .right-price-info {
            .tasheel-image {
              height: 20px;
            }
          }

          &.bordered {
            padding-bottom: 32px;
            border-bottom: 1px solid $secondary-gray-02;
          }
        }
      }

      @include desktop-min-width {
        min-width: 41.25%;
        max-width: 41.25%;
        display: block;
      }
    }
    .right-section {
      flex-basis: 100%;
      background-color: $primary-black;
      color: $primary-white;
      padding-top: 26px;

      @include desktop-min-width {
        // flex-basis: 58.75%;
        padding-top: 40px;
        min-width: 58.75%;
        max-width: 58.75%;
      }
    }
  }
</style>
